
define('template!sdcInputGroup',['directive!sdcInlineEditControls'],function(template){return '<sdc-inline-edit-controls ng-class="model.controlClass"></sdc-inline-edit-controls>\r\n';});

